import { createSelector } from 'reselect';

import {
    TRAVEL_MODES_IS_ACTIVE_DEFAULT,
} from '../constants';
import { selectRawFilterData } from './general';

function _selectTravelModes(state, filterId) {
    return selectRawFilterData(state, filterId).travelModes;
}

const selectTravelModesFilterData = createSelector(
    _selectTravelModes,
    (travelModes) => Object.entries(travelModes)
        .reduce((map, [mode, state]) => ({
            ...map,
            [mode]: {
                state,
            },
        }), {}),
);

function _isTravelModesFiltered(travelModeMap) {
    return Object.values(travelModeMap).some((isActive) => {
        return isActive !== TRAVEL_MODES_IS_ACTIVE_DEFAULT;
    });
}

const selectTravelModesIsFiltered = createSelector(
    _selectTravelModes,
    _isTravelModesFiltered,
);

export {
    selectTravelModesFilterData,
    selectTravelModesIsFiltered,
};
